export const initialState = {
  sourceType: "PDF",
  isIncludeImageChecked: false,
  isIncludePdfChecked: false,
  uploadFileData: null,
  multipleFile: [],
  selectedCategories: null,
  bloomFireOption: "",
  jobId: "",
  Name: "",
  UrlValue: "",
  Link: "",
  UrlDepth: "",
  Frequency: "",
  Seeker: null,
  Expert: null,
  Categories: null,
  usageAccess: "public",
  groupId: 1,
  similarDocs: false,
  payloadData: false,
  Response: null,
  showModal: false,
  oldSoid: "",
  showButton: false,
  loading: false,
  pageRefresh: false,
  FrequencyListData: null,
  seekerEmail: false,
  expertEmail: false,
  inputUploadValue: false,
  Catogarie: false,
  enableMultiple: false,
  domainIds:[]
};

const atomizerPageReducer = (state = initialState, { type, payload }) => {

  switch (type) {
    case "changeJobId":
      state = { ...state, jobId: payload };
      return state;
    case "uploadFile":
      state = { ...state, uploadFileData: payload };
      return state;
    case "selectType":
      state = {...state, domainIds:[]};
      state = { ...state, sourceType: payload };
      return state;
    case "name":
      state = { ...state, Name: payload };
      return state;
    case "link":
      state = { ...state, Link: payload };
      return state;
    case "urlChange":
      state = { ...state, UrlDepth: payload };
      return state;
    case "freqChange":
      state = { ...state, Frequency: payload };
      return state;
    case "response":
      state = { ...state, Response: payload };
      return state;
    case "soId":
      state = { ...state, oldSoid: payload };
      return state;
    case "modal":
      state = { ...state, showModal: payload };
      return state;
    case "bool":
      state = { ...state, payloadData: payload };
      return state;
    case "reset":
      state = {
        ...state,
        // sourceType: payload.sourceType,
        uploadFileData: payload.uploadFileData,
        jobId: payload.jobId,
        isIncludeImageChecked: payload?.isIncludeImageChecked,
        isIncludePdfChecked: payload?.isIncludePdfChecked,
        bloomFireOption: payload.bloomFireOption,
        Name: payload?.Name,
        UrlDepth: payload?.UrlDepth,
        Frequency: payload?.Frequency,
        Seeker: payload?.Seeker,
        Expert: payload?.Expert,
        Categories: payload?.Categories,
        Link: payload?.Link,
        UrlValue: payload?.UrlValue,
        dropDown: payload?.dropDown,
        selectedCategories: payload?.selectedCategories,
        categoriesId: payload?.categoriesId,
        domainIds: [],
        expertEmail: payload?.expertEmail,
        Catogarie: payload?.Catogarie,
        enableMultiple: payload?.enableMultiple,
      };
      return state;
    case "checkImage":
      state = { ...state, isIncludeImageChecked: payload };
      return state;
    case "checkPdf":
      state = { ...state, isIncludePdfChecked: payload };
      return state;
    case "showButton":
      state = { ...state, showButton: payload };
      return state;
    case "loader":
      state = { ...state, loading: payload };
      return state;
    case "seeker":
      state = { ...state, Seeker: payload };
      return state;
    case "expert":
      state = { ...state, Expert: payload };
      return state;
    case "urlValue":
      state = { ...state, UrlValue: payload };
      return state;
    case "categories":
      state = { ...state, Categories: payload };
      return state;
    case "Refresh":
      state = { ...payload };
      return state;
    case "categoriesId":
      state = { ...state, selectedCategories: payload };
      return state;
    case "selectDropDown":
      state = { ...state, dropDown: payload };
      return state;
    // case "Refresh"
    case "initialPage":
      state = {
        ...state,
        sourceType: payload?.sourceType,
        jobId: payload?.jobId,
        domainIds:[]
      };
      return state;
    case "frequencyList":
      state = { ...state, FrequencyListData: payload };
      return state;
    case "uploadFileError":
      state = { ...state, sourceType: payload };
      state = { ...state, domainIds: [] };
      return state;
    case "handleResetCategories":
      state = { ...state, Catogarie: payload };
      return state;
    case "handleReserSeeker":
      state = { ...state, seekerEmail: payload };
      return state;
    case "enableMutliple":
      state = { ...state, enableMutliple: payload };
      return state;
    case "domainAtomizerUpdate":
        state = { ...state, domainIds: payload };
        return state;
    default:
      return state;
  }
};
export default atomizerPageReducer;
